// Styles here will override Bulma styles
import { css } from '@emotion/core';
import media from 'css-in-js-media';

export const secondaryNavLink = css`
  font-size: 14px;
  margin: 12px 8px 11px 16px;

  :last-of-type {
    margin-right: 28px;
  }

  ${media('<desktop')} {
    margin-left: 8px;
    margin-right: 0;
    padding: 10px 16px !important;

    :last-of-type {
      margin-left: 8px;
    }
  }

  ${media('<tablet')} {
    font-size: 1em;
    margin: 16px !important;
    padding: 16px 32px !important;
  }
`;
